<h4 class="chartTitle">{{ chartTitle() }}</h4>
<div class="pieChartDiv" [id]="chartdiv_id"></div>
